import { Outlet } from 'react-router-dom';
import CommonLayout from './common';

export default function LogoOnlyLayout() {
  return (
    <CommonLayout>
      <Outlet />
    </CommonLayout>
  );
}
